import { render, staticRenderFns } from "./list.vue?vue&type=template&id=eda55dfe&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/shared-admin-styles.css?vue&type=style&index=0&id=eda55dfe&prod&scoped=true&lang=css&external"
import style1 from "./list.vue?vue&type=style&index=1&id=eda55dfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eda55dfe",
  null
  
)

export default component.exports